import React from 'react'

export default function Footer() {
  return (
    <div className="footerdiv" style={{background:"#000D14", display:"flex", justifyContent:"space-between", alignItems:"center", padding: "16px 4% 16px 4%",
    boxSizing: "border-box"}}>
        <p style={{textAlign:"center", display:"block"}}>💙 Thank you for visiting!</p>
        <p style={{textAlign:"center", display:"block" }}>Designed and Developed by 💙 Samay S. Dhawale, 2023 All right reserved. </p>
    </div>
  )
}
